__webpack_require__.p = "https://medicinskaordinacija.com/";